module.exports = __webpack_public_path__ + "public/StoreIcon/groceryorderFour.svg?9e609429";